// Swiper is fetched only on pages with a carousel, so it stays out of the main bundle.
const loadSwiper = () => import("./swiper-bundle")

export default (params = { slidesPerView: 1 }, destroyOnResize = false) => ({
  swiper: null,
  initialized: false,
  productContainer: null,
  init() {
    this.initSlider()
    this.productContainer = document.getElementById("main-product")
    if (destroyOnResize) {
      this.destroyOnresize()
      window.addEventListener("resize", () => this.destroyOnresize())
    }
  },
  async initSlider() {
    if (this.$el.classList.contains("swiper")) {
      const { Swiper, Autoplay, Navigation, Pagination, Thumbs, Scrollbar, Mousewheel } = await loadSwiper()
      this.swiper = new Swiper(this.$el, {
        modules: [Navigation, Pagination, Thumbs, Autoplay, Scrollbar, Mousewheel],
        ...params,
        on: {
          slideChange: (event) => {

            if (this.$el.classList.contains('modal-swiper')){
              let index_currentSlide = event.realIndex
              let currentSlide = event.slides[index_currentSlide]
              let videoContainer = currentSlide.querySelector(".video-container")
              const video = this.productContainer.querySelectorAll("video")

              if (!videoContainer && video.length) {
                video.forEach(vid => {
                  vid.pause()
                })
              }
              currentSlide.click()
            }
          },
        },
      })
    }
    this.initialized = true
  },
  slideToIndex(index) {
    this.swiper.slideToLoop(index, 10)
  },
  destroyOnresize() {
    if (window.innerWidth > 990 && this.swiper) {
      this.swiper.destroy()
    } else {
      this.initSlider()
    }
  },
})
